import {
  Alert,
  AlertTitle,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
} from "@mui/material";
import useConfirmation from "../hooks/useConfirmation";

const CVPreview = ({ open, handleClose, cv, handleEnvoie }) => {
  // const [confirmation, setConfirmation] = useState(true);
  const { DialogComponent, openConfirmDialog } = useConfirmation();

  // const handleValider = () => {
  //   handleEnvoie();
  //   handleClose();
  // };

  const handleConfirmSend = () => {
    openConfirmDialog(
      "Confirmer l’envoi de votre candidature",
      `Avez-vous vérifié que les informations introduites sont complètes et correctes avant de soumettre votre candidature ? `,
      () => {
        handleEnvoie();
        handleClose();
      },
      () => {},
    );
  };
  return (
    <Dialog open={open} onClose={handleClose} fullScreen>
      <DialogComponent />
      <DialogTitle>Aperçu du CV</DialogTitle>
      <DialogContent>
        {/* <iframe src={cv} width="100%" height="500px" title="CV" style={{border: "none"}}/> */}
        <Grid container height={"100%"}>
          <embed src={`${cv}#zoom=150`} type="application/pdf" width="100%" />
          {/* <iframe src={cv} width="100%" title="Aperçu du CV" height="100%" /> */}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Grid container justifyContent={"space-between"} pr={1} pl={1}>
          <Grid item mb={1} xs={12} /* textAlign={"end"} */>
            {/* <FormControlLabel
            title="Veuillez confirmer que les informations sur le CV sont correctes"
              control={
                <Checkbox
                  value="Confirmation"
                  checked={confirmation}
                  onChange={(e) => setConfirmation(e.target.checked)}
                />
              }
              sx={{
                color: "text.warning",
              }}
              label={<p style={{color: "text.warning"}}>Je confirme que <b>les informations</b> sur mon CV sont <b>complètes</b> et <b>correctes</b>.</p>}
              name="type"
            /> */}
            <Alert severity="warning">
              <AlertTitle>
                <b>Confirmation</b>
              </AlertTitle>
              Avant de soumettre votre candidature, Veuillez verifier que les
              informations sur le CV ci-dessus soient complètes et correctes.
            </Alert>
          </Grid>
          <Grid item>
            <Button onClick={handleClose}>Revenir</Button>
          </Grid>
          <Grid item>
            <Button
              variant="contained"
              onClick={handleConfirmSend}
              // disabled={!confirmation}
            >
              soumettre
            </Button>
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  );
};

export default CVPreview;
